import React from "react";

interface BadgeProps {
  label: string;
}

const Badge: React.FC<BadgeProps> = ({ label }) => {
  return <div className="tags-badge">{label}</div>;
};

export default Badge;
